module.exports = __webpack_public_path__ + "img/749DCBE9905D3849.44f1eefb.png";